module.exports = '/ng-templates/commons/conversation/loan-request-form/templates/slot-visit-orderability.tpl.ftl';
